module.exports = __webpack_public_path__ + "static/media/rainsound.e2693736.mp3";